<template>
  <div id="app">
    <MenuBar ref="MenuBar" @LoadedStoreSettings="LoadedStoreSettings"/>
    <router-view v-if="storeSettingsLoaded && storeLicenseValid" style="margin-top:-7px;"/>

    <vue-progress-bar></vue-progress-bar>
    <div class="popupmessage-container">
      <popupmessage v-for="(popupmessage, imessage) in popupmessages" :message="popupmessage" :key="imessage + 'i'"/>
    </div>
    <div>
      <dropdowncontainer v-for="(popup, indexP) in genericPopups" :state="popup" :key="popup.created" @on-close="CheckDropdownContainers"/>
    </div>
    <div>
      <popupalert v-for="(popupalert, ialert) in popupalerts" :message="popupalert" :key="ialert + 't'"/>
    </div>

    <rosterresult v-if="loggedIn && (storeSettings && !storeSettings.simpleMode && validAsLicense)"></rosterresult>
    <userchat v-if="loggedIn"></userchat>
    <vertxeventbus v-if="loggedIn"></vertxeventbus>
    <eventlog ref="eventlog"/>
    <datepicker :state="datepickerState" v-on:datepicker-date-picked="datepickerState.callback"></datepicker>
    <dropdowncontainer :state="tooltipState" ref="tooltip"/>
    <autologout v-if="loggedIn"></autologout>
  </div>
</template>
<script>
  import MenuBar from './components/MenuBar.vue';
  import popupmessage from './components/uicomponents/popupmessage.vue';
  import popupalert from './components/uicomponents/popupalert.vue';
  import datepicker from './components/uicomponents/datepicker.vue';
  import dropdowncontainer from './components/uicomponents/dropdowncontainer.vue';
  import rosterresult from './components/rostercontext/RosterResult.vue';
  import userchat from './components/chatcontext/UserChat.vue';
  import vertxeventbus from './components/VertxEventBus.vue';
  import eventlog from './components/EventLog.vue';
  import Dropdowncontainer from "./components/uicomponents/dropdowncontainer";
  import autologout from "./components/AutoLogout.vue"
  import { mapState, mapGetters } from 'vuex';
  import { loadavg } from 'os';

  export default{
    name: 'app',
    components: {
      Dropdowncontainer,
      MenuBar,
      datepicker,
      popupmessage,
      popupalert,
      rosterresult,
      userchat,
      eventlog,
      vertxeventbus,
      autologout
    },
    data() {
        return {
            popupmessages: [],
            popupalerts: [],
            genericPopups: [],
            datepickerState: {
              toggled: false,
              selectedDate: undefined,
              date: undefined,
              posx: 0,
              posy: 0,
              monthView: false,
              yearViewAllowed: true,
              dayViewAllowed: true,
              items: [],
              posxstart: 0,
              posystart: 0,
              appendedData: {},
              yearView: false,
              noEdit: false,
              elRelative: null,
              showOptions: true,
              CountMap: null,
              callback: () => {},
            },
            tooltipState: {
              toggled: false,
              elRelative: null,
            },
            mouseMoveSubscriptions: {}, //key -> function($event)
            storeSettingsLoaded: false,
        }
    },
    created(){
      document.addEventListener('keydown', this.KeyboardNavigationHandler);
      document.addEventListener('mousemove', this.WatchMouse);
      document.addEventListener('mousemove', this.MouseMoveSubscriptionHandler);
      document.addEventListener('mousedown', this.WatchMouse);
      document.addEventListener('mouseup', this.WatchMouse);
        document.addEventListener("touchstart", this.TouchEventToMouseEvent, {passive: false});
        document.addEventListener("touchmove", this.TouchEventToMouseEvent,  {passive: false});
        document.addEventListener("touchend", this.TouchEventToMouseEvent,  {passive: false});
        document.addEventListener("touchcancel", this.TouchEventToMouseEvent,  {passive: false});
      window.mouse = {x: 0, y: 0, click: false, element: {}};
      window.app = this;


    },
    destroyed(){
      document.removeEventListener('keydown', this.KeyboardNavigationHandler);
      document.removeEventListener('mousemove', this.WatchMouse);
      document.removeEventListener('mousemove', this.MouseMoveSubscriptionHandler);
      document.removeEventListener('mousedown', this.WatchMouse);
      document.removeEventListener('mouseup', this.WatchMouse);
        document.removeEventListener("touchstart", this.TouchEventToMouseEvent, {passive: false});
        document.removeEventListener("touchmove", this.TouchEventToMouseEvent,  {passive: false});
        document.removeEventListener("touchend", this.TouchEventToMouseEvent,  {passive: false});
        document.removeEventListener("touchcancel", this.TouchEventToMouseEvent,  {passive: false});
        this.$children.forEach(c => {
            if(c.$el) c.$el.remove();
            c.$destroy();
        });
    },
    computed: {
        ...mapGetters(['storeSettings', 'validAsLicense']),
        storeLicenseValid(){
          let valid = false;
          if(this.storeSettings != null){
              let licExpiry = this.storeSettings.licExpiry;
              let licMoment = this.$helpers.getMomentFromStringTZ(licExpiry).add(72, 'hours');
              let now = this.$helpers.getMomentTZ();
              valid = now < licMoment;
          }
          return valid;
        },
        loggedIn() {
            return this.$store.state.loggedIn;
        }
    },
    methods: {
      LoadedStoreSettings(){
          this.storeSettingsLoaded = true;
      },
      KeyboardNavigationHandler($event){

        let inputcomponent = document.activeElement && document.activeElement.closest('.input-component') ? document.activeElement.closest('.input-component').__vue__ : null;
        if(inputcomponent && $event.key.length === 1 && !inputcomponent.focused) {

               inputcomponent.FocusInput(false);
               inputcomponent.input = $event.key;
        }
        if($event.key === 'Escape'){
            if(inputcomponent){
                if(inputcomponent.focused) inputcomponent.ToggleItems(false);
            } else {
                let closable = this.$children.filter(c => c.Close && c.toggled && !c.tooltip);
                if(closable.length > 0) closable[closable.length - 1].Close();
            }
        } else if(($event.key === 'ArrowRight' || $event.key === 'ArrowLeft' || $event.key === 'ArrowUp' || $event.key === 'ArrowDown') && document.activeElement && document.activeElement.localName !== 'input' && document.activeElement.closest('.data-table')){
            let tableEl = document.activeElement.closest('.data-table');
            let rowEl = document.activeElement.closest('.row');
            let entryEl = document.activeElement.closest('.entry');
            let entries = rowEl.querySelectorAll('.entry');
            entries = Array.apply(null, entries);
            entries = entries.filter(e => !e.classList.contains('edit-disabled') && (e.querySelector('.button:not(.disabled) button') || e.querySelector('input')));
            let index = entries.indexOf(entryEl);
            entries = entries.map(e => e.querySelector('.button:not(.disabled) button') ? e.querySelector('.button:not(.disabled) button') : e.querySelector('input'));
            if($event.key === 'ArrowRight') {
                if(index < entries.length - 1) entries[index + 1].focus();
            } else if($event.key === 'ArrowLeft') {
                if(index > 0) entries[index - 1].focus();
            } else if($event.key === 'ArrowUp' || $event.key === 'ArrowDown') {

                let rows = tableEl.querySelectorAll('.row');
                rows = Array.apply(null, rows);
                let rowIndex = rows.indexOf(rowEl);
                let direction = $event.key === 'ArrowUp' ? -1 : 1;
                if(rowIndex + direction !== -1 && rowIndex + direction !== rows.length) {
                    let entriesNew = rows[rowIndex + direction].querySelectorAll('.entry');
                    entriesNew = Array.apply(null, entriesNew);
                    entriesNew = entriesNew.filter(e => !e.classList.contains('edit-disabled') && (e.querySelector('.button:not(.disabled) button') || e.querySelector('input'))).map(e => e.querySelector('.button:not(.disabled) button') ? e.querySelector('.button:not(.disabled) button') : e.querySelector('input'));
                    entriesNew[index].focus();
                }
            }
            $event.preventDefault();

        }

      },
      MouseMoveSubscribe(key, subscribeFunction){
        this.mouseMoveSubscriptions[key] = subscribeFunction;
      },
      MouseMoveUnsubscribe(key){
        delete this.mouseMoveSubscriptions[key];
      },
      MouseMoveSubscriptionHandler($event){
        for(let x in this.mouseMoveSubscriptions){
          this.mouseMoveSubscriptions[x](window.mouse.element);
        }
      },
      ToggleTooltip(element, state){
        let nstate = {tooltip: true, elRelative: element, pinBottom: true, ...state};
        if(!nstate.pointerDirection) nstate.pointerDirection = 2;
        if(!nstate.offsety) nstate.offsety = 5;
        this.tooltipState = nstate;
      },
      CheckTooltipShouldClose(container){
        if(this.$refs.tooltip && this.$refs.tooltip.toggled && this.$refs.tooltip.elRelative && this.CheckChildTooltip(container, this.$refs.tooltip.elRelative)) {
            this.$refs.tooltip.toggled = false;
            this.$refs.tooltip.header = '';
            this.$refs.tooltip.type = '';
            this.$refs.tooltip.componentState = null;
        }
      },
      CheckChildTooltip(container, element){
          if(!element || element === document || !container) return false;
          if(element === container) return true;
          return this.CheckChildTooltip(container, element.parentNode);
      },
      RepositionTooltip(){
        let view = this;
        let element = this.$children.find(c => c.state === view.tooltipState);
        if(element){
          element.Reposition();
        }
      },
      CheckDropdownContainers(dropdowncontainer){
        let view = this;
        if(this.$children.filter(c => view.genericPopups.find(g => c.state === g)).every(c => !c.toggled)) view.genericPopups = [];
      },
      TouchEventToMouseEvent($event)
      {
          var touches = $event.changedTouches,
              first = touches[0],
              type = "";
          switch($event.type)
          {
              case "touchstart": type = "mousedown"; break;
              case "touchmove":
              {
                if(window.roster && window.roster.dayMode) $event.preventDefault();
                type = "mousemove";
                break;
              }
              case "touchend":   type = "mouseup";   break;
              default:           return;
          }

          var simulatedEvent = document.createEvent("MouseEvent");
          simulatedEvent.initMouseEvent(type, true, true, window, 1,
                                        first.screenX, first.screenY,
                                        first.clientX, first.clientY, false,
                                        false, false, false, 0/*left*/, null);

          first.target.dispatchEvent(simulatedEvent);
          //$event.preventDefault();
      },
      WatchMouse($event) {
        if($event.type === 'mousedown' && $event.which === 1) window.mouse.click = true;
        if($event.type === 'mouseup' && $event.which === 1) window.mouse.click = false;
        if($event.type === 'mousemove') {
          window.mouse.x = $event.clientX;
          window.mouse.y = $event.clientY;
          window.mouse.element = document.elementFromPoint($event.clientX, $event.clientY);
        }
      },
    }
  }
</script>

<style>
  @import './assets/styles/texttooltip.css';
  @import './assets/styles/colors_dark.css';
  @import './assets/styles/colors_light.css';
  @import './assets/styles/md.css';
  @import './assets/styles/fontawesome.css';
  @import './assets/styles/all.min.css';
  @import './assets/styles/md_750px.css';
  @import './assets/styles/md_1380px.css';
  @import './assets/styles/dropdown.css';
  @import './assets/styles/bootstrap.css';
  @import './assets/styles/bootstrap-vue.css';

  #app{
    background: var(--bg);
  }
</style>
